module.exports = __webpack_public_path__ + "img/logo.3e727d47.jpg";